import { useContext, useEffect } from "react";
import { ContextApp } from "@config/Context/contextApp";
import { sessionAssignationStore, useSessionAssignationStore } from "@context/sessionAssignation";
import { AppContext } from "../../context/EditSessionsContext";

export const useSessionAssignationPolicy = (isAssignationLocked: boolean) => {
  const { user } = useContext(ContextApp);
  const { state } = useContext(AppContext);
  const sections = useSessionAssignationStore(draft => draft.sections);
  const courseCanEdit =
    sections.length > 0 && sections.every(section => section.course?.edhCanEdit === true);
  const thresholdDate = state.form.blockingThreshold;
  useEffect(() => {
    sessionAssignationStore.getState().setPolicy({
      permissions: user?.permissions ?? {},
      abilities: user?.abilities ?? {},
      courseCanEdit,
      isAssignationLocked,
      thresholdDate,
    });
  }, [user?.permissions, user?.abilities, courseCanEdit, isAssignationLocked, thresholdDate]);
};
